import React, { useEffect, useState } from 'react'
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { toast } from 'react-toastify';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';

const MatchTypeEditForm = (props) => {
    const lang = useTranslation();

    const blankDataItem = {
        ...props.item,
        Duration: props.item.Duration ? utility.convertMilisecondsToStringWithFrames(props.item.Duration) : "00:00:00:00",
        Description: props.item.copy ? "Copy of " + props.item.Description : props.item.Description ?? "",
        Archive: props.item.Archive ?? false,
        ParentPgRating: props?.item?.ParentPgRating ?? "",
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [tournamentTypes, setTournamentTypes] = useState([]);

    useEffect(() => {
        loadCombo()
    }, [])

    const loadCombo = async () => {
        let tournamentTypeRes = await API.getDataLookup(ENTITYNAME.TournamentType, { sort: { Description: 1 } });
        setTournamentTypes(tournamentTypeRes.data)
    }

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {

        if (dataItem.Description == undefined || dataItem.Description == "") {
            toast.error(`${lang.please_enter_description_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        return true;

    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        var durationLocal = utility.convertStringWithFramesToMilliseconds(dataItem.Duration);
        const saveData = {
            _id: dataItem._id,
            SID: dataItem.SID,
            Description: dataItem.Description,
            Archive: dataItem.Archive ?? false,
            TournamentType: dataItem?.TournamentType && Object.keys(dataItem?.TournamentType).length > 0 ? {
                _id: dataItem?.TournamentType?._id,
                Description: dataItem?.TournamentType?.Description
            } : {},
            Duration: durationLocal,
            checkDuplicate: true,
            query: [["Description", "=", dataItem.Description]]

        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.MatchType, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.MATCHTYPE, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.MatchType);
        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    return (
        <>
            <BossDialog
                title={props.item.Description ?? lang.match_type_dialog_header}
                onClose={props.cancelEdit}
                width={"600px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />

                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <label>{lang.description_label} *</label>
                                <input
                                    name={"Description"}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem.Description}
                                />
                            </div>
                            <div className="col-6">
                                <label>{lang.tournament_type_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    className="form-control form-control-sm"
                                    data={tournamentTypes}
                                    name="TournamentType"
                                    textField="Description"
                                    dataItemKey="_id"
                                    onChange={onChange}
                                    value={dataItem.TournamentType}
                                />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="col-6">
                                <label htmlFor="">{lang.duration_label} </label>
                                <TimePickerWithFormat
                                    className="form-control form-control-sm"
                                    name="Duration"
                                    value={dataItem.Duration}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div className='col-6'>
                                <input
                                    style={{ border: "1px solid grey", marginTop: "26px" }}
                                    name={"Archive"}
                                    type='checkbox'
                                    onChange={onChange}
                                />
                                <label className="ml-2">{lang.archive}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog >
        </>
    )
}

export default MatchTypeEditForm
